export const AFFINE_LEFT_SIDEBAR_KEY_BINDING = '$mod+j';
export const AFFINE_RIGHT_SIDEBAR_KEY_BINDING = '$mod+l';
export const AFFINE_QUICK_SEARCH_KEY_BINDING = '$mod+K';

export const AFFINE_LEFT_SIDEBAR_SHORTCUT = ['$mod', 'J'];
export const AFFINE_RIGHT_SIDEBAR_SHORTCUT = ['$mod', 'L'];
export const AFFINE_QUICK_SEARCH_SHORTCUT = ['$mod', 'K'];
